import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { User } from 'firebase/auth';
import { UserProfile } from '@shared/types';

interface PublicRouteProps {
  children: React.ReactNode;
  user: User | null;
  userProfile?: UserProfile | null;
}

export function PublicRoute({ children, user, userProfile }: PublicRouteProps) {
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  if (user) {
    // User is authenticated, redirect based on role
    if (userProfile?.role === 'admin' || userProfile?.role === 'superadmin') {
      return <Navigate to="/admin" replace />;
    }
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
}

